module.exports = __webpack_public_path__ + "static/media/SWSCRC6-40.3dee5242.mp3";